<template>
  <div class="wrapper">
    <div class="top">
      <div class="tabs">
        <div
          class="tab"
          v-for="(item,index) in orderTypes"
          :key="index"
          @click="changeOrderType(index)"
          :class="{'active':statusIndex==index}"
        >{{item}}</div>
      </div>
      <div class="search">
        <input type="text" v-model="keyword" @input="inputChange" placeholder="输入拍品名称、拍品编号、订单号、手机号、收货人姓名" class="search-input">
        <div class="search-icon-wrap">
          <div class="search-icon" @click="searchOrder()">
            <i class="el-icon-search"></i>
          </div>
        </div>
		<img class="close-btn" v-show="keyword" src="../../assets/images/close.png" alt="" @click="delKeyword()">
      </div>
    </div>
    <div class="order-wrap" :class="{ 'has-merge-bar': selectedIds.length > 0 }">
      <div class="order-head order-box">
        <div class="order-select narrow-cell">
          <el-checkbox
            v-if="unpaidOrdersOnPage.length"
            :indeterminate="selectAllIndeterminate"
            v-model="selectAll"
          >全选</el-checkbox>
        </div>
        <div class="order-info">拍品</div>
        <div class="order-price">单价</div>
        <div class="order-num">数量</div>
        <div class="order-total-price">总价</div>
        <div class="order-state">订单状态</div>
        <div class="order-handle">操作</div>
      </div>
      <div v-if="orderList.length==0" class="no-order">
        <div v-show="statusIndex>0">没有{{orderTypes[statusIndex]}}的订单哟~</div>
        <div v-show="statusIndex==0">没有订单信息，快去下单吧~</div>
      </div>
      <div v-show="orderList.length>0">
        <el-checkbox-group v-model="selectedIds" class="merge-order-checkbox-group">
        <div class="order-item" v-for="(order,index) in orderList" :key="index">
          <div class="order-item-head order-head-row">
            <div class="order-head-meta">
              <span class="merge-check-cell">
                <el-checkbox
                  v-if="canMergePay(order)"
                  class="merge-row-checkbox"
                  :label="String(order.order_id)"
                ></el-checkbox>
              </span>
              <span class="time">{{orderTime(order.ctime)}}</span>
              订单号：
              <span class="code">{{order.order_id}}</span>
            </div>
          </div>
          <div class="order-item-main order-box">
            <div class="order-select narrow-cell"></div>
            <div class="order-info-list">
              <div class="order-li" v-for="(product,i) in order.items" :key="i">
                <img v-lazy="product.image_url" alt class="order-img">
                <div class="order-name">{{product.name}}</div>
                <div class="order-price">￥{{product.price}}</div>
                <div class="order-num">
                  <i class="icon iconfont iconchenghao">{{product.nums}}</i>
                </div>
              </div>
            </div>
            <div class="order-total-price">￥{{order.order_amount}}</div>
            <div class="order-state">
              <div class="order-status">{{getOrderStatus(order)}}</div>
              <router-link
                :to="{name:'orderDetail',params:{order_id:order.order_id}}"
                class="order-detail-link"
                tag="a"
              >订单详情</router-link>
            </div>
            <div class="order-handle">
              <template v-if="order.status === 1 && order.pay_status === 1">
                <router-link :to="{name:'cashier',params:{order_id:order.order_id}}">立即支付</router-link>
              </template>
              <template
                v-else-if="order.status === 1 && order.pay_status === 2 && order.ship_status === 3 && order.confirm === 1"
              >
                <span @click="tackDelivery(order.order_id)">确认收货</span>
              </template>
              <template
                v-else-if="order.status === 1 && order.pay_status === 2 && order.ship_status === 3 && order.confirm === 2 && order.is_comment === 1 && order.order_type != 12"
              >
                <router-link :to="{name:'evaluate',query:{order_id:order.order_id}}">立即评价</router-link>
              </template>
              <template v-else>
                <span>
                  <router-link v-if="order.order_type != 12" :to="{name:'detail',params:{goodsId:order.items[0].goods_id}}">再次购买</router-link>
                </span>
              </template>
            </div>
          </div>
        </div>
        <Pagination :totalPage="totalPage" :limit="limit" @changePage="handOrderMore"></Pagination>
        </el-checkbox-group>
      </div>
    </div>
    <div class="merge-pay-bar" v-if="selectedIds.length > 0">
      <span class="merge-pay-tip">已选择 <em>{{ selectedIds.length }}</em> 笔待付款订单</span>
      <el-button type="danger" size="medium" @click="goMergePay">合并付款</el-button>
    </div>
  </div>
</template>

<script>
import { showLoading, hideLoading } from '../../utils/loading'
import Pagination from "@/components/common/Pagination.vue";
import { timeToDate } from "@/utils";
export default {
  name: "MyOrder",
  components: { Pagination },
  props: {},
  data() {
    return {
      orderTypes: ["全部", "待付款", "待发货", "待收货", "待评价", "已评价", "已完成"],
      keyword: "",
      statusIndex: 0,
      orderList: [],
      totalPage: 0,
      page: 1,
      limit: 10,
      selectedIds: [],
    };
  },
  watch: {
    statusIndex(){
      this.initData();
      this.$route.query.type=this.statusIndex;
    }
  },
  computed: {
    orderTime() {
      return time => {
        return timeToDate(time);
      };
    },
    //获取订单状态文字显示
    getOrderStatus() {
      return order => {
        let orderStatusName;
        switch (order.status) {
          case 1:
            if (order.pay_status === 1) {
              orderStatusName = "待付款";
            }
            if (order.pay_status === 2 && order.ship_status === 1) {
              orderStatusName = "待发货";
            }
            if (
              order.pay_status === 2 &&
              order.ship_status === 3 &&
              order.confirm === 1
            ) {
              orderStatusName = "待收货";
            }
            if (
              order.pay_status === 2 &&
              order.ship_status === 3 &&
              order.confirm === 2 &&
              order.is_comment === 1
            ) {
              orderStatusName = "待评价";
            }
            if (
              order.pay_status === 2 &&
              order.ship_status === 3 &&
              order.confirm === 2 &&
              order.is_comment === 2
            ) {
              orderStatusName = "已评价";
            }
            if (order.pay_status === 4) {
              orderStatusName = "售后单";
            }
            break;
          case 2:
            orderStatusName = "已完成";
            break;
          case 3:
            orderStatusName = "已取消";
            break;
        }
        return orderStatusName;
      };
    },
    unpaidOrdersOnPage() {
      return this.orderList.filter(o => this.canMergePay(o));
    },
    selectAllIndeterminate() {
      const unpaid = this.unpaidOrdersOnPage;
      const n = unpaid.filter(o =>
        this.selectedIds.includes(String(o.order_id))
      ).length;
      return n > 0 && n < unpaid.length;
    },
    selectAll: {
      get() {
        const unpaid = this.unpaidOrdersOnPage;
        return (
          unpaid.length > 0 &&
          unpaid.every(o => this.selectedIds.includes(String(o.order_id)))
        );
      },
      set(val) {
        const unpaid = this.unpaidOrdersOnPage;
        if (val) {
          const add = unpaid.map(o => String(o.order_id));
          this.selectedIds = [...new Set([...this.selectedIds, ...add])];
        } else {
          const rm = new Set(unpaid.map(o => String(o.order_id)));
          this.selectedIds = this.selectedIds.filter(id => !rm.has(id));
        }
      }
    }
  },
  methods: {
	inputChange() {
	},
    initData() {
      this.orderList = [];
      this.selectedIds = [];
      this.getOrderList();
    },
    changeOrderType(index) {
		
      if (this.statusIndex == index) return;
      this.statusIndex = index;
	  showLoading();
    },
    //分页加载
    handOrderMore(val) {
      this.page = val;
      this.selectedIds = [];
      this.getOrderList();
    },
    //确认收货
    tackDelivery(order_id) {
      this.$confirm("确定已收到宝贝?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let data = {
          order_id: order_id
        };
        this.$api.confirmOrder(data).then(res => {
          if (res.status) {
            this.$msg("确认收货成功!");
            this.getOrderList();
          }
        });
      });
    },
	searchOrder(){
		this.selectedIds = [];
		this.getOrderList();
	},
	//删除关键词
	delKeyword(){
		this.keyword='';
		this.selectedIds = [];
		this.getOrderList();
	},
    canMergePay(order) {
      return Number(order.status) === 1 && Number(order.pay_status) === 1;
    },
    goMergePay() {
      if (!this.selectedIds.length) return;
      const order_id = this.selectedIds.join(",");
      this.$router.push({
        name: "cashier",
        params: { order_id }
      });
    },
    getOrderList() {
      let data = {
        page: this.page,
        limit: this.limit,
        status: this.statusIndex
      };
	  if(this.keyword){
		  data.keyword = this.keyword;
	  }
      this.$api.orderList(data).then(res => {
        if (res.status) {
          this.totalPage = Math.ceil(
            Number(res.data.count) / Number(this.limit)
          );
          this.orderList = res.data.list;
        }
		hideLoading();
      });
    }
  },
  created() {},
  mounted() {
	  showLoading();
    let query=this.$route.query;
    if(query.type){
      this.statusIndex=query.type
    }
    this.initData();
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.merge-order-checkbox-group {
  display: block;
  width: 100%;
}
.order-item {
  border: 1px solid $border;
  box-sizing: border-box;
  margin-bottom: 20px;
  .order-item-head {
    font-size: 12px;
    color: #757575;
    border-bottom: 1px solid $border;
    &.order-head-row {
      display: flex;
      align-items: center;
      min-height: 40px;
      line-height: 40px;
      padding-left: 12px;
      .order-head-meta {
        flex: 1;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        line-height: normal;
        .merge-check-cell {
          flex-shrink: 0;
          display: inline-flex;
          align-items: center;
          align-self: center;
          margin-right: 8px;
          line-height: 1;
          /* :label 必须保留（写入 selectedIds），但组件会把 label 渲染成文案；scoped 需穿透才能隐藏 */
          ::v-deep .merge-row-checkbox.el-checkbox {
            margin-right: 0;
            margin-bottom: 0;
            vertical-align: middle;
            .el-checkbox__label {
              display: none !important;
              padding-left: 0 !important;
              width: 0 !important;
              overflow: hidden !important;
            }
          }
        }
      }
    }
    .time {
      margin-right: 30px;
    }
  }
}
.order-box {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  .narrow-cell {
    width: 56px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  &.order-item-main {
    height: 100%;
    .order-info-list {
      border-right: 1px solid $border;
      width: 460px;
      .order-li {
        display: flex;
        align-items: center;
        &:not(:last-of-type) {
          border-bottom: 1px solid $border;
        }
        .order-img {
          display: block;
          width: 100px;
          height: 100px;
          object-fit: cover;
          margin-right: 10px;
        }
        .order-name {
          width: 200px;
          line-height: 20px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }
    }
  }
  &.order-head {
    @include line-height(40px);
    border-top: 1px solid $border;
    border-bottom: 1px solid $border;
    margin: 20px 0;
  }
  .order-info {
    width: 280px;
    text-indent: 20px;
  }
  .order-price {
    width: 100px;
    text-align: center;
  }
  .order-num {
    width: 90px;
    text-align: center;
    .icon {
      font-size: 12px;
    }
  }
  .order-total-price {
    width: 120px;
    text-align: center;
  }
  .order-state {
    width: 150px;
    text-align: center;
    .order-status {
      margin-bottom: 10px;
    }
    .order-detail-link {
      &:hover {
        color: $theme-color;
      }
    }
  }
  .order-handle {
    width: 150px;
    text-align: center;
    span,
    a {
      padding: 5px 0;
      cursor: pointer;
      &:hover {
        color: $theme-color;
      }
    }
  }
}
.wrapper {
  .top {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    align-items: center;
    .tabs {
      .tab {
        float: left;
        padding: 0 20px;
        cursor: pointer;
        &:hover {
          color: $theme-color;
        }
        &:first-of-type {
          padding-left: 0;
        }
        &:not(:last-of-type) {
          border-right: 1px solid $border;
        }
        &.active {
          color: $theme-color;
        }
        span {
          color: $theme-color;
        }
      }
    }
    .search {
      width: 355px;
      height: 40px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(220, 220, 220, 1);
      padding: 10px 0 10px 10px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      transition: all 0.2s;
      position: relative;
	  .close-btn {
		  position: absolute;
		  right: 50px;
		  top: 50%;
		  transform: translateY(-50%);
		  width: 20px;
		  height: 20px;
	  }
      &.active {
        border: 1px solid $theme-color;
      }
      .search-input {
        display: block;
        flex: 1;
        height: 20px;
      }
      .search-icon-wrap {
        display: inline-block;
        width: 40px;
        height: 40px;
        position: relative;
        border-left: 1px solid rgba(220, 220, 220, 1);
        transition: all 0.2s;
        cursor: pointer;
        &:hover {
          color: #fff;
          background: $theme-color;
        }
        &.active {
          border-color: $theme-color;
        }
        .search-icon {
          position: absolute;
          width: 20px;
          height: 20px;
          top: 10px;
          left: 10px;
          .el-icon-search {
            font-size: 20px;
          }
        }
      }
    }
  }
}
.no-order {
  height: 100px;
  line-height: 100px;
  text-align: center;
  font-size: 18px;
}
.order-wrap.has-merge-bar {
  padding-bottom: 72px;
}
.merge-pay-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
  padding: 14px 48px;
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  .merge-pay-tip {
    font-size: 14px;
    color: #666;
    em {
      font-style: normal;
      color: $theme-color;
      font-weight: 600;
    }
  }
}
</style>